import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { LEAD_FORM_CONVERSION_EVENT_NAME } from 'site-modules/shared/components/evolv/constants';

/**
 * Renders telephone link w/ or w/o text based on `showNumber` flag.
 * @param {String} linkClassName
 * @param {String} icon
 * @param {String} formattedPhone
 * @param {String} iconClassName
 * @param {Object} dealerInfo
 * @param {Boolean} showNumber
 * @returns {ReactElement}
 */
export class TelephoneLink extends Component {
  state = {
    isCTAClicked: false,
  };

  /**
   * Change CTA text when it's clicked
   */
  handleClickCTATextChange = e => {
    e.preventDefault();
    this.setState({ isCTAClicked: true });
  };

  render() {
    const {
      linkClassName,
      icon,
      formattedPhone,
      dealerInfo,
      iconClassName,
      showNumber,
      telephoneLinkCTAName,
      ...restLinkProps
    } = this.props;
    const { isCTAClicked } = this.state;

    if (!formattedPhone) {
      return null;
    }
    const { dataTrackingId, dataDealerFranchiseId, dataDealerRooftopId } = dealerInfo;

    const telephoneLinkContent = (
      <span>
        {showNumber ? (
          <>
            {icon && <i className={classnames('me-0_25', `icon-${icon}`)} aria-hidden />} {formattedPhone}
          </>
        ) : (
          <>
            {icon && <i className={classnames('me-0_25', `icon-${icon}`, iconClassName)} aria-hidden />}
            <span className="d-lg-none d-xl-inline">Call </span>
            <span className="d-md-none">Dealer </span>
            <span className="d-none d-md-inline">{formattedPhone}</span>
          </>
        )}
      </span>
    );

    const telephoneLinkContentCTA = (
      <>
        <i className={classnames('me-0_25', `icon-${icon}`, iconClassName)} aria-hidden />
        <span>{isCTAClicked ? formattedPhone : telephoneLinkCTAName}</span>
      </>
    );
    const telephoneLinkContentCTAProps = {
      onClick: isCTAClicked ? null : this.handleClickCTATextChange,
      'data-tracking-ignore-value': true,
    };

    return (
      <a
        className={linkClassName}
        href={`tel:${formattedPhone}`}
        data-tracking-id={dataTrackingId}
        data-dealer-franchise-id={dataDealerFranchiseId}
        data-dealer-rooftop-id={dataDealerRooftopId}
        data-evolv-conversion={LEAD_FORM_CONVERSION_EVENT_NAME}
        {...(telephoneLinkCTAName ? telephoneLinkContentCTAProps : {})}
        {...restLinkProps}
      >
        {telephoneLinkCTAName ? telephoneLinkContentCTA : telephoneLinkContent}
      </a>
    );
  }
}

TelephoneLink.propTypes = {
  linkClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  icon: PropTypes.string,
  formattedPhone: PropTypes.string,
  dealerInfo: PropTypes.shape({
    dataTrackingId: PropTypes.string,
    dataDealerFranchiseId: PropTypes.string,
    dataDealerRooftopId: PropTypes.number,
  }).isRequired,
  showNumber: PropTypes.bool,
  telephoneLinkCTAName: PropTypes.string,
};

TelephoneLink.defaultProps = {
  linkClassName: '',
  iconClassName: 'text-gray-dark',
  icon: 'phone2',
  formattedPhone: '',
  showNumber: false,
  telephoneLinkCTAName: '',
};
